import {Box, Flex, Heading, HStack, Image, Stack, Text, VStack} from "@chakra-ui/react";
import {Link, useNavigate} from "react-router-dom";
import {useParams} from "react-router-dom";
import {Blogs} from "../../../helpers/data-jsons";
import {ReactComponent as Back} from "../../../assets/icons/back.svg";

const BlogView = () => {
    const {id} = useParams();
    const blog = Blogs.find((b) => Number(b.id) === Number(id))
    return (
        <Stack
            maxW={'1344px'}
            m={'auto'}
            p={{base: '24px 0', md: '24px 16px'}}
            gap={'24px'}
        >
            <Heading
                display={'flex'}
                alignItems={'center'}
                gap={'4px'}
                width={{base: '95%', md: 'full'}}
                margin={'auto'}
                textAlign={'start'}
                color={'neutral.100'}
                fontSize={'heading.3xl'}
            >
                <Box
                    as={Link}
                    to={'/blog'}
                >
                    <Back/>
                </Box>
                News blog</Heading>
            <Box
                display={'flex'}
                flexDirection={'column'}
                gap={'48px'}
                w={'full'}
                margin={'auto'}
                bg={'neutral.1100'}
                p={{base: '24px 16px', md: '24px 32px'}}
                borderRadius={{base: '0', md: '16px'}}>
                <Box>
                    <Image maxH={'355px'}
                           borderTopLeftRadius={'16px'}
                           borderTopRightRadius={'16px'}
                           w={'full'}
                           objectFit={'cover'}
                           src={'/images/' + blog.imgUrl}/>
                </Box>
                <Box
                    color={'neutral.100'}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'16px'}
                >
                    <Heading
                        fontSize={'24px'}
                        color={'neutral.100'}>
                        Why is Bitcoin price up today?
                    </Heading>
                    ontrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                    classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin
                    professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words,
                    consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical
                    literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33
                    of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This
                    book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of
                    Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
                    The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
                    Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in
                    their exact original form, accompanied by English versions from the 1914 translation by H.
                    Rackham.
                </Box>
            </Box>
        </Stack>
    )
}
export default BlogView